import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBLXleQ28dQR-uDTKlYXSevefzc0vowh9k",
  authDomain: "gyanchu-horse-racing-app.firebaseapp.com",
  databaseURL: "https://gyanchu-horse-racing-app-default-rtdb.firebaseio.com",
  projectId: "gyanchu-horse-racing-app",
  storageBucket: "gyanchu-horse-racing-app.firebasestorage.app",
  messagingSenderId: "427377004973",
  appId: "1:427377004973:web:48fc4f3ee9796731039124",
  measurementId: "G-75KP9PB5YT"
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);

const getMessagingIfSupported = async () => {
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(app);
};

const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

export { app, database, auth, getMessagingIfSupported, vapidKey, firebaseConfig };
